module.exports = __webpack_public_path__ + "images/category_lp/farm_machine/store_images/1@2x_1f0d1a2107bc4db60b0bce14f858db9a.png";